'use client';

import { Swiper, SwiperSlide } from 'swiper/react';

import { SmallCard } from '@/shared/components/smallCard';
import { SmallCardProps } from '@/shared/components/smallCard/ui/types';

export const Slider = ({
  smallCards,
  cardCustomClassNames = {},
}: {
  smallCards: SmallCardProps[];
  cardCustomClassNames?: SmallCardProps['customClassNames'];
}) => {
  return (
    <Swiper spaceBetween={12} slidesPerView="auto" className="!px-5 !py-2">
      {smallCards.map(
        (
          { imageSrc, imageData, href, description, subDescription, alt },
          index,
        ) => (
          <SwiperSlide key={index}>
            <SmallCard
              key={index}
              descriptionId={description as string}
              imageSrc={imageSrc}
              imageData={imageData}
              href={href}
              description={description}
              subDescription={subDescription}
              alt={alt}
              customClassNames={{
                content: '!text-[16px] !leading-[24px]',
                main: 'min-h-[308px]',
                ...cardCustomClassNames,
              }}
            />
          </SwiperSlide>
        ),
      )}
    </Swiper>
  );
};
